<template>
    <div class="row">
        <div class="col-12" >
            <h4 class="full-width" v-if="showadd">{{$t('PROMOTIONS.bulkPrices')}}</h4>
            <div class="row" v-if="newPromotion">
                <div class="col-12">
                    <el-form ref="bulk-promotion" label-position="left" label-width="75px">
                        <el-form-item label="Price">
                                <vue-numeric class="form-control-sm mb-0 greycolors"
                                         :currency="symbol"
                                         :separator="decimalSeparator"
                                         :decimal-separator="separator"
                                         currency-symbol-position="suffix"
                                         :precision="fractionalDigits"
                                         :min="0"
                                         @blur="changeHandler"
                                         v-model="newPromotion.price"></vue-numeric>
                        </el-form-item>
                        <el-form-item :label="$t('COMMON.quantity')">
                                <el-input size="mini" class="w-400 grey" v-model.number="newPromotion.quantity" @blur="changeHandler"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div v-show="!noTable" v-for="(promotion, index) in sortedPromotions"
                 :key="`promotion-bulk-${promotion.id}-${index}`" class="row">
                <div class="col-12 col-md-6 col-lg-5 d-flex align-items-center">
                    <p>{{$t('COMMON.quantity')}}
                        <strong>{{promotion.quantity}}</strong>
                    </p>
                </div>
                <div class="col-8 col-md-3 col-lg-4 d-flex justify-content-center align-items-center">
                    <p>{{$t('COMMON.price')}} <strong>
                        <vue-numeric :decimal-separator="decimalSeparator"
                                     :currency="symbol"
                                     currency-symbol-position="suffix"
                                     :read-only="true"
                                     :precision="fractionalDigits"
                                     :value="promotion.price"></vue-numeric>
                        </strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FormInput from '../../Shared/UI/Form/FormInput';
import CphButton from '../../Shared/UI/Button/CphButton';
import VueNumeric from 'vue-numeric';
import VueCheckboxToggle from '../../Shared/Toggler';

export default {
    name: 'bulk-promotions',
    data () {
        return {
            newPromotion: {
                price: 0,
                productId: this.productChosen.id,
                quantity: 0, // products volume
                original: this.originalPriceId, //standard price id
                active: false, // is promotion active
                type: 'bulk' // bulk or period
            },
            message: '',
        };
    },
    components: {
        CphButton,
        FormInput,
        VueNumeric,
        VueCheckboxToggle
    },
    computed: {
        sortedPromotions () {
            return this.bulkPromotions.sort((a, b) => a.quantity - b.quantity);
        }
    },
    props: {
        bulkPromotions: {},
        productChosen: {},
        showadd: {
            type: Boolean,
        },
        newPromotionData: {
            type: Object,
            default: null
        },
        symbol: '',
        noTable: {
            default: false,
            type: Boolean
        },
        fractionalDigits: 0,
        decimalSeparator: {
            deafult: "."
        },
        separator: {
             default: ","
        }
    },
    watch: {
        newPromotion(newVal, oldVal) {
            this.newPromotion = newVal;
        }
    },
    methods: {
        changeHandler(){
            if (this.newPromotion.quantity < 0) {
                this.message = 'Quantity has to be greater than 0';
                return;
            }
            if (this.newPromotion.price < 0) {
                this.message = 'Price has to be greater than 0';
                return;
            }
            if (this.newPromotion.price > this.standardPrice) {
                this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.higherPrice'), shouldGoToPrevPage: false,
                    callback: (decision = false) => {
                        if(decision) {
                            this.$emit('addPromotion', {promotion: {...this.newPromotion}, type: 'bulk'});
                        }
                    }});
            }else {
                this.$emit('addPromotion', {promotion: {...this.newPromotion}, type: 'bulk'});
            }
        },
    }
};
</script>

<style lang="scss" scoped>
  .greycolors {
    border: 1px solid #DCDFE6;
    width: 15vw;
    min-width: 4rem;
  }
  div.grey div.el-input.el-input--mini input.el-input__inner {

  }
  .w-400{
      width: 15vw;
      min-width: 4rem;
  }
</style>
